export default __webpack_public_path__ + "static/media/tel.0837e94f.png";